import { getFilteredListQuery, getListQuery, getSingleQuery } from "../queries";

export default {
  gqlType: "StrapiContent",
  listQuery: getListQuery("StrapiContent"),
  filteredListQuery: getFilteredListQuery("StrapiContent"),
  singleQuery: getSingleQuery("StrapiContent"),
}
